"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bonusPluralize = exports.dayPluralize = exports.channelPluralize = exports.monthPluralize = void 0;
/**
 * Склонения для месяца
 *
 * @return ['месяц', 'месяца', 'месяцев']
 */
exports.monthPluralize = ['месяц', 'месяца', 'месяцев'];
/**
 * Склонения для канала
 *
 * @return ['канал', 'канала', 'каналов']
 */
exports.channelPluralize = ['канал', 'канала', 'каналов'];
/**
 * Склонения для дня
 *
 * @return ['день', 'дня', 'дней']
 */
exports.dayPluralize = ['день', 'дня', 'дней'];
/**
 * Склонения для бонуса
 *
 * @return ['бонус', 'бонуса', 'бонусов']
 */
exports.bonusPluralize = ['бонус', 'бонуса', 'бонусов'];
